import {AttackOriginLocationHorizontal, AttackDestinationLocation, AttackDestinationLocationVertical, AttackDestinationLocationHorizontal} from "sandy-shared/dist/types/attack-info.type";
import { CourtSide } from "sandy-shared/dist/types/court-info.type";
import {ServeInPlayLocation, ServePlayerRelativeLocation} from "sandy-shared/dist/types/servce-info.type";

export const getServeInPlayLocation = (locationIndex: number): ServeInPlayLocation => {
  const side = locationIndex <= 2 ? CourtSide.Left : CourtSide.Right;
  if(locationIndex % 3 === 0) return ({side, playerRelativeLocation: ServePlayerRelativeLocation.Left})
  if(locationIndex % 3 === 1) return ({side, playerRelativeLocation: ServePlayerRelativeLocation.Middle})
  if(locationIndex % 3 === 2) return ({side, playerRelativeLocation: ServePlayerRelativeLocation.Right})
  throw new Error('Invalid serve in play location');
}

export const getAttackOriginLocationHorizontal = (index: number): AttackOriginLocationHorizontal => {
  if(index === 0) return AttackOriginLocationHorizontal.One;
  if(index === 1) return AttackOriginLocationHorizontal.Two;
  if(index === 2) return AttackOriginLocationHorizontal.Three;
  if(index === 3) return AttackOriginLocationHorizontal.Four;
  if(index === 4) return AttackOriginLocationHorizontal.Five;
  throw new Error('Invalid attack location index');
}

export const getAttackDestinationLocationVertical = (rowIndex: number): AttackDestinationLocationVertical => {
  if(rowIndex === 0) return AttackDestinationLocationVertical.Deep;
  if(rowIndex === 1) return AttackDestinationLocationVertical.Middle;
  if(rowIndex === 2) return AttackDestinationLocationVertical.Shallow;
  throw new Error('Invalid attack destination location vertical');
} 

export const getAttackDestinationLocationHorizontal = (colIndex: number): AttackDestinationLocationHorizontal => {
  if(colIndex === 0) return AttackDestinationLocationHorizontal.One;
  if(colIndex === 1) return AttackDestinationLocationHorizontal.Two;
  if(colIndex === 2) return AttackDestinationLocationHorizontal.Three;
  if(colIndex === 3) return AttackDestinationLocationHorizontal.Four;
  if(colIndex === 4) return AttackDestinationLocationHorizontal.Five;
  throw new Error('Invalid attack destination location horizontal');
}

export const getAttackDestinationLocation = (rowIndex: number, colIndex: number): AttackDestinationLocation => {
  return {
    horizontal: getAttackDestinationLocationHorizontal(colIndex),
    vertical: getAttackDestinationLocationVertical(rowIndex),
  }
}

